import { render, staticRenderFns } from "./add_card.vue?vue&type=template&id=4a4a1ef4&scoped=true"
import script from "./add_card.vue?vue&type=script&lang=js"
export * from "./add_card.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/consumables.css?vue&type=style&index=0&id=4a4a1ef4&prod&scoped=true&lang=css&external"
import style1 from "../../assets/css/doctor-detail.css?vue&type=style&index=1&id=4a4a1ef4&prod&scoped=true&lang=css&external"
import style2 from "../../assets/css/case_management_add_case.css?vue&type=style&index=2&id=4a4a1ef4&prod&scoped=true&lang=css&external"
import style3 from "./add_card.vue?vue&type=style&index=3&id=4a4a1ef4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4a1ef4",
  null
  
)

export default component.exports